import { initReactI18next } from "react-i18next"
import { APP_LOCALE } from "@constants"
import ja from "./ja"
import i18n from "i18next"

i18n.use(initReactI18next).init({
  debug: false,
  resources: {
    ja: {
      translation: ja,
    },
  },
  lng: APP_LOCALE || "ja",
  react: {
    wait: true,
    useSuspense: false,
  },
  interpolation: {
    prefix: "{",
    suffix: "}",
    escapeValue: false,
  },
  supportedLngs: ["ja"],
})

export default i18n
